// Topbar.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { handleLogout } from "../../login/AuthUtils.js";
import "./Topbar.css";

const Topbar = ({ selectedTask, clearSelectedTask }) => {
  const navigate = useNavigate();
  const storedData = localStorage.getItem("userObjectArray");
  let username = "Guest";

  if (storedData) {
    try {
      const parsedData = JSON.parse(storedData);
      if (Array.isArray(parsedData) && parsedData[0]?.name) {
        username = parsedData[0].name;
      }
    } catch (err) {
      console.error("Error parsing userObjectArray:", err);
    }
  }

  // const onLogout = () => {
  //   handleLogout();
  //   navigate("/login");
  // };

  return (
    <div className="topbar">
      <span className="username">👤 Hii, {username}</span>

      {selectedTask && (
        <div className="task-summary">
          <span><strong>Task ID:</strong> {selectedTask.taskid}</span>
          <span><strong>Filename:</strong> {selectedTask.filename}</span>
          <span><strong>Status:</strong> {selectedTask.status}</span>
          <button
            className="btn-clear"
            onClick={clearSelectedTask}
            title="Clear task details"
          >
            ✖
          </button>
        </div>
      )}

      {/* <button className="logout-btn" onClick={onLogout}>
        🔓 Logout
      </button> */}
    </div>
  );
};

export default Topbar;
